import SparlesLightIcon from '@/assets/icons/sparles-light.svg?react';
interface InsightBlockProps {
  show: boolean;
  aiInsight: string | null | undefined;
}

export function InsightBlock({ show, aiInsight }: InsightBlockProps) {
  if (!show) return null;
  return (
    <div className="min-h-[36px] max-h-[54px] mt-3 flex flex-row items-start gap-1 bg-[#F5F5F5] rounded-lg p-2">
      <SparlesLightIcon className=" shrink-0" />
      <p className="text-xs text-[#262626] leading-[150%] tracking-[0.018em] line-clamp-2 min-w-0">{aiInsight}</p>
    </div>
  );
}
